import React from 'react';
import { Styles } from '../styles';

export const ReviewCardSkeleton: React.FC = () => {
  return (
    <svg
      data-qa="review-card-skel_mf-pdp"
      className={Styles.reviewCardSkeletonView}
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M80 74.859L84.944 78l-1.312-5.92L88 68.097l-5.752-.514L80 62l-2.248 5.583-5.752.514 4.368 3.983L75.056 78 80 74.859zm-18 0L66.944 78l-1.312-5.92L70 68.097l-5.752-.514L62 62l-2.248 5.583-5.752.514 4.368 3.983L57.056 78 62 74.859zm-18 0L48.944 78l-1.312-5.92L52 68.097l-5.752-.514L44 62l-2.248 5.583-5.752.514 4.368 3.983L39.056 78 44 74.859zm-18 0L30.944 78l-1.312-5.92L34 68.097l-5.752-.514L26 62l-2.248 5.583-5.752.514 4.368 3.983L21.056 78 26 74.859zm-18 0L12.944 78l-1.312-5.92L16 68.097l-5.752-.514L8 62l-2.248 5.583L0 68.097l4.368 3.983L3.056 78 8 74.859z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24z"
      />
      <path d="M60 16h60v16H60z" />
      <rect y="92" width="25.714%" height="16" />
      <rect y="124" width="100%" height="16" />
      <rect y="148" width="82.857%" height="16" />
      <rect y="172" width="71.429%" height="16" />
      <rect y="196" width="65.714%" height="16" />
      <rect y="228" width="40%" height="16" />
      <rect y="260" width="40%" height="16" />
      <rect y="296" width="72" height="40" rx="20" />
      <rect x="80" y="296" width="72" height="40" rx="20" />
    </svg>
  );
};

export const ReviewsPaginationPageSkeleton: React.FC<{ cardsNumber?: number }> = ({ cardsNumber = 10 }) => {
  return (
    <div>
      {new Array(cardsNumber).fill(null).map((elem, index) => (
        <ReviewCardSkeleton key={index} />
      ))}
    </div>
  );
};

export const ReviewsShowMoreButtonSkeleton: React.FC = () => {
  return <div data-qa="review-show-more-skel_mf-pdp" className={Styles.showMoreButtonSkeleton} />;
};
